"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CopyableText = exports.COPYABLE_TEXT_BUTTON_VISIBILITY = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _ButtonIcon = require("b2b-components/theme/components/ButtonIcon");
var _Icon = require("b2b-components/theme/components/Icon");
var _classnames = _interopRequireDefault(require("classnames"));
var _upperCaseFirst = require("upper-case-first");
var _Content = require("./Content");
var _CopyButton = require("./CopyButton");
require("./CopyableText.scss");
var COPYABLE_TEXT_BUTTON_VISIBILITY = /*#__PURE__*/function (COPYABLE_TEXT_BUTTON_VISIBILITY) {
  COPYABLE_TEXT_BUTTON_VISIBILITY["always"] = "always";
  COPYABLE_TEXT_BUTTON_VISIBILITY["hover"] = "hover";
  return COPYABLE_TEXT_BUTTON_VISIBILITY;
}({});
exports.COPYABLE_TEXT_BUTTON_VISIBILITY = COPYABLE_TEXT_BUTTON_VISIBILITY;
var CopyableText = function CopyableText(_ref) {
  var children = _ref.children,
    value = _ref.value,
    deviceType = _ref.deviceType,
    isTooltipEnabled = _ref.isTooltipEnabled,
    isTriggerCopyOnTextClick = _ref.isTriggerCopyOnTextClick,
    isCopyButtonVisible = _ref.isCopyButtonVisible,
    getTooltipText = _ref.getTooltipText,
    onCopyableTextMouseEnter = _ref.onCopyableTextMouseEnter,
    onCopyableTextMouseLeave = _ref.onCopyableTextMouseLeave,
    onCopyButtonTransitionEnd = _ref.onCopyButtonTransitionEnd,
    className = _ref.className,
    _ref$buttonSize = _ref.buttonSize,
    buttonSize = _ref$buttonSize === void 0 ? _ButtonIcon.BUTTON_ICON_SIZE.small : _ref$buttonSize,
    _ref$buttonTouchscree = _ref.buttonTouchscreenVisibility,
    buttonTouchscreenVisibility = _ref$buttonTouchscree === void 0 ? COPYABLE_TEXT_BUTTON_VISIBILITY.always : _ref$buttonTouchscree,
    _ref$buttonVisibility = _ref.buttonVisibility,
    buttonVisibility = _ref$buttonVisibility === void 0 ? COPYABLE_TEXT_BUTTON_VISIBILITY.hover : _ref$buttonVisibility,
    _ref$iconName = _ref.iconName,
    iconName = _ref$iconName === void 0 ? _Icon.ICON_NAME.copy : _ref$iconName;
  var rootClassName = (0, _classnames["default"])('cds-CopyableText', {
    'cds-CopyableText--DesktopVisible': buttonVisibility === COPYABLE_TEXT_BUTTON_VISIBILITY.always,
    'cds-CopyableText--MobileVisible': buttonTouchscreenVisibility === COPYABLE_TEXT_BUTTON_VISIBILITY.always,
    'cds-CopyableText--Extended': isTriggerCopyOnTextClick
  }, className);
  var contentClassName = (0, _classnames["default"])('cds-CopyableText-Content', (0, _defineProperty2["default"])({}, "cds-CopyableText-Content--".concat((0, _upperCaseFirst.upperCaseFirst)(buttonSize)), buttonSize));
  var valueToCopy = value;
  if (!value && typeof children === 'string') {
    valueToCopy = children;
  }
  if (!valueToCopy) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: rootClassName,
    onMouseEnter: onCopyableTextMouseEnter,
    onMouseLeave: onCopyableTextMouseLeave
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-CopyableText-Wrapper"
  }, isTriggerCopyOnTextClick ? /*#__PURE__*/_react["default"].createElement(_Content.Content, {
    className: contentClassName,
    getTooltipText: getTooltipText,
    value: valueToCopy
  }, children) : /*#__PURE__*/_react["default"].createElement("span", {
    className: contentClassName
  }, children), /*#__PURE__*/_react["default"].createElement(_CopyButton.CopyButton, {
    buttonSize: buttonSize,
    deviceType: deviceType,
    getTooltipText: getTooltipText,
    iconName: iconName,
    isCopyButtonVisible: isCopyButtonVisible,
    isTooltipEnabled: isTooltipEnabled,
    onTransitionEnd: onCopyButtonTransitionEnd,
    value: valueToCopy
  })));
};
exports.CopyableText = CopyableText;